export default __webpack_public_path__ + "static/media/editPrice.5c2792fc.svg";